import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=5c440258&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=ts&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports